module.exports = {
      id: "v-plus-logo-usage",
      viewBox: "0 0 165.404 72.698",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#v-plus-logo",
      toString: function () {
        return this.url;
      }
    }